import { render, staticRenderFns } from "./SalaryTaxMonth.vue?vue&type=template&id=76bdb648&scoped=true"
import script from "./SalaryTaxMonth.vue?vue&type=script&lang=js"
export * from "./SalaryTaxMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bdb648",
  null
  
)

export default component.exports